import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class IndividualSalesReportAPI {

  static getIndividualLeadsStatus = (filters, success, failure) => {
    const body = { filters:filters}
    fetch(Config.app.link + 'api/getIndividualLeadsStatus', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static getIndividualLeadSource = (filters, success, failure) => {
    const body = { filters:filters}
    fetch(Config.app.link + 'api/getIndividualLeadSource', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static getIndividualLeadsAllocated = (filters, success, failure) => {
    const body = { filters:filters}
    fetch(Config.app.link + 'api/getIndividualLeadsAllocated', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static getIndividualLeadsByProject = (filters, success, failure) => {
    const body = { filters:filters}
    fetch(Config.app.link + 'api/getIndividualLeadsByProject', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static getIndividualCall = (filters, success, failure) => {
    const body = { filters:filters}
    fetch(Config.app.link + 'api/getIndividualCall', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getIndividualCallTalktime = (filters, success, failure) => {
    const body = {filters:filters}
    fetch(Config.app.link + 'api/getIndividualCallTalktime', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static getIndividualCallFeedback = (filters, success, failure) => {
    const body = {filters:filters}
    fetch(Config.app.link + 'api/getIndividualCallFeedback', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

 static getIndividualCallsInOut = (filters, success, failure) => {
    const body = {filters:filters}
    fetch(Config.app.link + 'api/getIndividualCallsInOut', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  
  static IndividualMeetingReport = (filters, success, failure) => {
    const body = {filters:filters}
    fetch(Config.app.link + 'api/getIndividualMeetingReport', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static getIndividualMeetingFeedback = (filters, success, failure) => {
    const body = {filters:filters}
    fetch(Config.app.link + 'api/getIndividualMeetingFeedback', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static getIndividualMeetingByProject = (filters, success, failure) => {
    const body = {filters:filters}
    fetch(Config.app.link + 'api/getIndividualMeetingByProject', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static getIndividualPropertyByConfiguration = (filters, success, failure) => {
    const body = {filters:filters}
    fetch(Config.app.link + 'api/getIndividualPropertyByConfiguration', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static getIndividualLeadsByRentSale = (filters, success, failure) => {
    const body = {filters:filters}
    fetch(Config.app.link + 'api/getIndividualLeadsByRentSale', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static getPropertyBySalesPerson = (filters, success, failure) => {
    const body = {filters:filters}
    fetch(Config.app.link + 'api/getPropertyBySalesPerson', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static getIndividualQuoteReport = (filters, success, failure) => {
    const body = {filters:filters}
    fetch(Config.app.link + 'api/getIndividualQuoteReport', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static getIndividualQuoteStatus = (filters, success, failure) => {
    const body = {filters:filters}
    fetch(Config.app.link + 'api/getIndividualQuoteStatus', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static getIndividualQuoteAmount = (filters, success, failure) => {
    const body = {filters:filters}
    fetch(Config.app.link + 'api/getIndividualQuoteAmount', new Header('POST' , body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
 

 
}

export default IndividualSalesReportAPI;